import styled from 'styled-components';

interface IHeaderContainer {
  type: 'reclamation' | 'answer';
}

export const HeaderContainer = styled.div<IHeaderContainer>`
  display: flex;
  flex-direction: row;
  justify-content: ${({ type }) => type === 'reclamation' ? 'flex-start' : 'flex-end'};
  align-items: center;
  width: 100%;
  margin-bottom: 6px;

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;

    .avatar {
      overflow: hidden;
      border-radius: 50%;
      width: 28px;
      height: 28px;
      min-width: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${({ theme, type }) => type === 'reclamation' ? theme.colors.danger.light : theme.colors.primary.light};
      border: 2px solid ${({ theme, type }) => type === 'reclamation' ? theme.colors.danger.main : theme.colors.primary.main};

      span {
        color: ${({ theme, type }) => type === 'reclamation' ? theme.colors.danger.dark : theme.colors.primary.dark};
        font-weight: 700;
        text-align: center;
        text-transform: uppercase;
        font-size: 12px;
      }
    }

    .user-info {
      display: flex;
      flex-direction: column;
      gap: 1px;

      strong {
        font-size: 13px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.gray[900]};
        line-height: 1.2;
      }

      .meta {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 11px;
        color: ${({ theme }) => theme.colors.gray[200]};

        .channel-badge {
          background: ${({ theme }) => theme.colors.primary.main};
          color: #fff;
          padding: 2px 8px;
          border-radius: 8px;
          font-size: 10px;
          font-weight: 600;
        }
      }
    }

    .type-icon {
      width: 16px;
      height: 16px;
      opacity: 0.7;
    }
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 8px;

    img {
      &:hover{
        opacity: 0.5;
        transition: ease-in 0.2s;
      }
      &:not(:hover) {
        opacity: 1;
        transition: ease-in 0.2s;
      }
    }

    a {
      background: transparent;
      border: none;
      /* width: 23px;
      height: 23px; */

      img {
        padding: 0;
        width: 23px;
      }
      img {
        padding: 0;
        width: 23px;
      }
      }

    a.qrCodeLink {
      padding: 0;
      width: 24px;
      margin-top: 1px;

      img {
        width: 100% !important;
      }
    }

    button {
      border: none;
      background: transparent;
      /* margin-right: 8px; */


      img {
        padding: 0;
        width: 23px;
      }
    }

    button.profileImage {
      overflow: hidden;
      border-radius: 50%;
      border: 1px solid ${({ theme }) => theme.colors.gray[201]};
      width: 23px;
      height: 23px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
`;
